var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-text-field"},[_c('label',{staticClass:"auth-text-field__label"},[_vm._v(_vm._s(_vm.label))]),_c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false","min-height":"50px"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }